import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import FixButton from "../../widgets/Button";
import TimezoneSelect from "../../widgets/TimezoneSelect";
//import TimePicker from 'react-time-picker';
import ManageEventService from '../../services/manageEvent';
import moment from 'moment';

export default class CreateEvent extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Create event";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.setState({});
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          <TextInput name={'Event name '} value={this.state.eventName} 
            onChange={(text) => { this.setState({eventName: text})}
          } />

          <MyDatePicker ref={this.startDateRef} name={'Start date'}/>
          <MyDatePicker ref={this.endDateRef} name={'End date'}/>
          
          <TimezoneSelect ref={this.tzRef} name={'Timezone'} handleChange={(val) => {this.setState({timezone: val});} } />

          <FixButton title={'Save'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      const adminId = cookies.get('adminId', { path: '/' });

      const xStartDate = this.startDateRef.current.getDate();
      const xEndDate = this.endDateRef.current.getDate();

      let startDate = moment(xStartDate).format('DD/MM/yyyy');
      let endDate = moment(xEndDate).format('DD/MM/yyyy');

      if (xEndDate < xStartDate){
        alert ('Check the event dates, please');
        return;
      }

      let startHour = moment(xStartDate).format('HH');
      let startMinutes = moment(xStartDate).format('mm');
      let endHour = moment(xEndDate).format('HH');
      let endMinutes = moment(xEndDate).format('mm');
  

      if (this.state.eventName == '') return;
      
      let ret = await ManageEventService (username, token, adminId, false, '', this.state.eventName, startDate, startHour, startMinutes,
                endDate, endHour, endMinutes, 12, '', '', true, 
                '', '', '', '', false, false, '', '', '', this.state.timezone, '');

      if (ret.result == 'ok'){
        window.location.href = '/#/app/eventslist';
      }
      else {
        alert ('An error occurred while creating a new event.')
      }
  }

}

